__turbopack_context__.v({
  "items": "side-nav-module__jWQ0Ra__items",
  "sideNav": "side-nav-module__jWQ0Ra__sideNav",
  "sideNavExpanded": "side-nav-module__jWQ0Ra__sideNavExpanded",
});
